module.exports = __webpack_public_path__ + "img/intro_image_new.04538f5f.png";